import { render, staticRenderFns } from "./G_060_ShukkaJunbi_ChildHeaderInput.vue?vue&type=template&id=12c8e8ce&scoped=true&"
import script from "./G_060_ShukkaJunbi_ChildHeaderInput.vue?vue&type=script&lang=ts&"
export * from "./G_060_ShukkaJunbi_ChildHeaderInput.vue?vue&type=script&lang=ts&"
import style0 from "./G_060_ShukkaJunbi_ChildHeaderInput.vue?vue&type=style&index=0&id=12c8e8ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c8e8ce",
  null
  
)

export default component.exports